// extracted by mini-css-extract-plugin
export default {"content":"style_content__KYB7O","ant-table-tbody":"style_ant-table-tbody__xHqB8","checkbox":"style_checkbox__Z+B1e","footer":"style_footer__1eHlU"};